<template>
    <v-row no-gutters class="my-10" justify="center" align="center">
        <v-col cols="4" align="end" class="mb-5">
            <div>
                <img
                    :src="require('@/assets/grafiti-crown.png')"
                    :height="$vuetify.breakpoint.mobile ? '100px' : '150px'"
                    :aspect-ratio="16/9"
                    contain
                >
            </div>
            <div>
                <img
                    :height="$vuetify.breakpoint.mobile ? '100px' : '150px'"
                    :aspect-ratio="16/9"
                    :src="require('@/assets/main_logo.png')"
                    contain
                >
            </div>
        </v-col>
        <v-col cols="4" align="center">
            <img
                v-if="player.image"
                :height="$vuetify.breakpoint.mobile ? '200px' : '350px'"
                :aspect-ratio="16/9"
                :src="`${assetsUrl}/${player.image}`"
                class="clickable"
                contain
                @click="$router.push({path:`/Player/${player.id}`})"
                @error="player.image = null"
            >
            <img
                v-else
                :height="$vuetify.breakpoint.mobile ? '200px' : '250px'"
                :aspect-ratio="16/9"
                :src="require('@/assets/main_logo.png')"
                :style="$vuetify.breakpoint.mobile ? 'position: absolute; left: 0; top: 650px;' : 'position: absolute; left: 620px; top: 500px;'"
                contain
            >
        </v-col>
        <v-col cols="4" align="start">
            <div>
                <img
                    :src="require('@/assets/main_logo.png')"
                    :height="$vuetify.breakpoint.mobile ? '100px' : '150px'"
                    :aspect-ratio="16/9"
                    contain
                >
            </div>
            <div>
                <img
                    :src="require('@/assets/MVP-TAG.png')"
                    :height="$vuetify.breakpoint.mobile ? '100px' : '150px'"
                    :aspect-ratio="16/9"
                    contain
                >
            </div>
        </v-col>
        <v-col cols="12" align="center" class="mb-5">
            <div class="mvp-text font-weight-bold custom-teal-text">
                {{ `${player.name} ${player.surname}` }}
            </div>
        </v-col>
        <v-col cols="12" align="center">
            <v-row class="pb-5">
                <v-col
                    v-for="(stat, index) in stats"
                    :key="index"
                    cols="2"
                    class=" mx-0 px-5"
                    style="text-transform: capitalize;"
                    align="center"
                >
                    <div class="circle-border">
                        <div class="secondary-font text-h4">
                            {{ player.stats[0][stat.value] }}
                        </div>
                        <div class="custom-teal-text text-h5">
                            {{ stat.text }}
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            player: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                stats: [
                    { text: 'Pts', value: 'points' },
                    { text: 'TR', value: 'rebounds' },
                    { text: 'AST', value: 'assists' },
                    { text: 'STL', value: 'steals' },
                    { text: 'TO', value: 'turnovers' },
                    { text: 'BLK', value: 'blockedShots' }
                ],
                assetsUrl: 'https://storage.googleapis.com'
            }
        }
    }
</script>

<style scoped>
.circle-border {
    border-radius: 50%;
    border: 7px solid #ff7133;
    width: 190px;
    height: 190px;
    padding: 60px;
    background: white;
    text-align: center;
}

.text-h5 {
    font-size: 1.5rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.mvp-text {
    font-size: 2rem !important;
    letter-spacing: normal !important;
    font-family: Arial, sans-serif !important;
}

.text-h4 {
    font-size: 2.125rem !important;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
}

.top-arc {
    border-width: 2px;
    border-radius: 10px 5% / 20px 25em 30px 35em;
    border-color: teal;
}
</style>
